import { render, staticRenderFns } from "./form-can-edit.vue?vue&type=template&id=1ec788cc&"
import script from "./form-can-edit.vue?vue&type=script&lang=js&"
export * from "./form-can-edit.vue?vue&type=script&lang=js&"
import style0 from "./form-can-edit.vue?vue&type=style&index=0&id=1ec788cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports